define("@ember/runloop/type-tests.ts/cancel.test", ["@ember/runloop", "expect-type"], function (_runloop, _expectType) {
  "use strict";

  var runNext = (0, _runloop.next)(null, () => {// will not be executed
  });
  (0, _expectType.expectTypeOf)((0, _runloop.cancel)(runNext)).toEqualTypeOf();
});